import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import './DataPage.css';

const styles = {
  page: {
    padding: '24px',
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    fontFamily: 'Inter, Roboto, "Open Sans", sans-serif',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  },
  pageSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  loadingIndicator: {
    marginLeft: '8px',
    color: '#1976d2',
  },
  countersRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
  },
  counterCard: (color) => ({
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    borderLeft: `4px solid ${color}`,
  }),
  counterLabel: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px',
  },
  counterValue: {
    fontSize: '1.75rem',
    fontWeight: '700',
    color: '#333',
  },
  filtersCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 200px',
  },
  filterLabel: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: '600',
    marginBottom: '6px',
  },
  searchInput: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    transition: 'border-color 0.2s',
    width: '100%',
    boxSizing: 'border-box',
  },
  filterSelect: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  clearButton: {
    padding: '10px 18px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s',
  },
  btnNovo: {
    padding: '10px 20px',
    backgroundColor: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  tableCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  tableResponsive: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.9rem',
  },
  th: {
    padding: '12px 16px',
    textAlign: 'left',
    fontWeight: '600',
    color: '#666',
    backgroundColor: '#fafafa',
    borderBottom: '2px solid #eee',
    fontSize: '0.8rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    whiteSpace: 'nowrap',
    userSelect: 'none',
  },
  td: {
    padding: '12px 16px',
    color: '#333',
    borderBottom: '1px solid #f0f0f0',
    verticalAlign: 'middle',
  },
  trEven: {
    backgroundColor: '#fafafa',
  },
  badgeAtivo: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: '600',
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
  },
  badgeBloqueado: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.78rem',
    fontWeight: '600',
    backgroundColor: '#ffebee',
    color: '#c62828',
  },
  actionButton: {
    padding: '6px 12px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.8rem',
    fontWeight: '500',
    transition: 'background-color 0.2s',
    marginRight: '4px',
  },
  editButton: {
    backgroundColor: '#e3f2fd',
    color: '#1565c0',
  },
  blockButton: {
    backgroundColor: '#ffebee',
    color: '#c62828',
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    color: '#999',
  },
  loadingState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#666',
    fontSize: '1rem',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px',
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    maxWidth: '800px',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  modalHeader: {
    padding: '24px',
    borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: '1.25rem',
    fontWeight: '700',
    color: '#333',
    margin: 0,
  },
  modalCloseButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.5rem',
    color: '#999',
    cursor: 'pointer',
    padding: '4px 8px',
    lineHeight: 1,
    borderRadius: '4px',
  },
  modalBody: {
    padding: '24px',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '16px',
    marginBottom: '24px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  formGroupFull: {
    display: 'flex',
    flexDirection: 'column',
    gridColumn: '1 / -1',
  },
  formLabel: {
    fontSize: '0.8rem',
    color: '#666',
    fontWeight: '600',
    marginBottom: '6px',
  },
  formInput: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  formTextarea: {
    padding: '10px 14px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '0.9rem',
    color: '#333',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    resize: 'vertical',
    minHeight: '80px',
  },
  modalFooter: {
    padding: '16px 24px',
    borderTop: '1px solid #eee',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
  },
  btnCancelar: {
    padding: '10px 20px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500',
  },
  btnSalvar: {
    padding: '10px 20px',
    backgroundColor: '#2e7d32',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '600',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    padding: '20px 0',
    flexWrap: 'wrap',
  },
  paginationBtn: (active) => ({
    padding: '8px 14px',
    border: active ? 'none' : '1px solid #ddd',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: active ? '600' : '400',
    backgroundColor: active ? '#1976d2' : '#fff',
    color: active ? '#fff' : '#333',
    transition: 'all 0.2s',
  }),
  paginationInfo: {
    fontSize: '0.85rem',
    color: '#666',
    margin: '0 8px',
  },
};

function Laudos() {
  const navigate = useNavigate();
  const [laudos, setLaudos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [contadores, setContadores] = useState({ total: 0, ativos: 0, bloqueados: 0 });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const [filtros, setFiltros] = useState({
    search: '',
    material: '',
    metodo: '',
    bloqueado: 'false',
  });

  const [materiais, setMateriais] = useState([]);
  const [metodos, setMetodos] = useState([]);

  // Modal
  const [modalOpen, setModalOpen] = useState(false);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [formData, setFormData] = useState({
    ID: '', DESCRICAO: '', SINONIMO: '', MATERIAL: '', METODO: '',
    SEXO: '', DIASENTREGA: '', PREPARO: '', OBSPADRAO: '',
    CODIGO_TUSS: '', BLOQUEADO: 'F',
  });

  const [hoveredRow, setHoveredRow] = useState(null);

  useEffect(() => {
    carregarMateriais();
    carregarMetodos();
  }, []);

  useEffect(() => {
    carregarLaudos();
  }, [filtros, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filtros.search, filtros.material, filtros.metodo, filtros.bloqueado]);

  const carregarLaudos = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filtros.search) params.append('search', filtros.search);
      if (filtros.material) params.append('material', filtros.material);
      if (filtros.metodo) params.append('metodo', filtros.metodo);
      if (filtros.bloqueado) params.append('bloqueado', filtros.bloqueado);

      const response = await axios.get(`${API_URL}/laudos?${params.toString()}`);
      const data = Array.isArray(response.data) ? response.data : [];
      setTotalItems(data.length);

      const ativos = data.filter(l => l.BLOQUEADO !== 'T').length;
      const bloqueados = data.filter(l => l.BLOQUEADO === 'T').length;
      setContadores({ total: data.length, ativos, bloqueados });

      const startIndex = (currentPage - 1) * itemsPerPage;
      setLaudos(data.slice(startIndex, startIndex + itemsPerPage));
    } catch (err) {
      console.error('Erro ao carregar laudos:', err);
    } finally {
      setLoading(false);
    }
  };

  const carregarMateriais = async () => {
    try {
      const response = await axios.get(`${API_URL}/materiais`);
      setMateriais(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error('Erro ao carregar materiais:', err);
    }
  };

  const carregarMetodos = async () => {
    try {
      const response = await axios.get(`${API_URL}/metodos`);
      setMetodos(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error('Erro ao carregar metodos:', err);
    }
  };

  const abrirModalNovo = () => {
    setModoEdicao(false);
    setFormData({
      ID: '', DESCRICAO: '', SINONIMO: '', MATERIAL: '', METODO: '',
      SEXO: '', DIASENTREGA: '', PREPARO: '', OBSPADRAO: '',
      CODIGO_TUSS: '', BLOQUEADO: 'F',
    });
    setModalOpen(true);
  };

  const abrirModalEdicao = async (laudo) => {
    try {
      const response = await axios.get(`${API_URL}/laudos/${laudo.ID}`);
      const data = response.data;
      setModoEdicao(true);
      setFormData({
        ID: data.ID || '',
        DESCRICAO: data.DESCRICAO || '',
        SINONIMO: data.SINONIMO || '',
        MATERIAL: data.MATERIAL || '',
        METODO: data.METODO || '',
        SEXO: data.SEXO || '',
        DIASENTREGA: data.DIASENTREGA || '',
        PREPARO: data.PREPARO || '',
        OBSPADRAO: data.OBSPADRAO || '',
        CODIGO_TUSS: data.CODIGO_TUSS || '',
        BLOQUEADO: data.BLOQUEADO || 'F',
      });
      setModalOpen(true);
    } catch (err) {
      console.error('Erro ao carregar laudo:', err);
      alert('Erro ao carregar dados do laudo');
    }
  };

  const fecharModal = () => {
    setModalOpen(false);
    setModoEdicao(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.ID || !formData.DESCRICAO) {
      alert('Codigo e Descricao sao obrigatorios');
      return;
    }
    try {
      if (modoEdicao) {
        await axios.put(`${API_URL}/laudos/${formData.ID}`, formData);
      } else {
        await axios.post(`${API_URL}/laudos`, formData);
      }
      alert(`Laudo ${modoEdicao ? 'atualizado' : 'criado'} com sucesso!`);
      fecharModal();
      carregarLaudos();
    } catch (err) {
      console.error('Erro ao salvar laudo:', err);
      alert(err.response?.data?.error || err.message);
    }
  };

  const bloquearLaudo = async (id) => {
    if (!window.confirm('Tem certeza que deseja bloquear este laudo?')) return;
    try {
      await axios.delete(`${API_URL}/laudos/${id}`);
      alert('Laudo bloqueado com sucesso!');
      carregarLaudos();
    } catch (err) {
      console.error('Erro ao bloquear laudo:', err);
      alert('Erro ao bloquear laudo');
    }
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (loading && laudos.length === 0) {
    return <div style={styles.loadingState}>Carregando laudos...</div>;
  }

  return (
    <div className="data-page" style={{ backgroundColor: '#f5f5f5', minHeight: '100vh', fontFamily: 'Inter, Roboto, "Open Sans", sans-serif' }}>
      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>📄</span>
          <div>
            <h1 style={styles.pageTitle}>Laudos</h1>
            <p style={styles.pageSubtitle}>
              Exibindo {laudos.length} de {totalItems} registros
              {(filtros.search || filtros.material || filtros.metodo || filtros.bloqueado) && ' (filtrado)'}
              {loading && <span style={styles.loadingIndicator}> Carregando...</span>}
            </p>
          </div>
        </div>
        <button
          style={styles.btnNovo}
          onClick={abrirModalNovo}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#1565c0'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = '#1976d2'; }}
        >
          + Novo Laudo
        </button>
      </div>

      {/* Contadores */}
      <div className="responsive-grid" style={styles.countersRow}>
        <div style={styles.counterCard('#1976d2')}>
          <div style={styles.counterLabel}>Total de Laudos</div>
          <div style={styles.counterValue}>{contadores.total}</div>
        </div>
        <div style={styles.counterCard('#2e7d32')}>
          <div style={styles.counterLabel}>Ativos</div>
          <div style={{ ...styles.counterValue, color: '#2e7d32' }}>{contadores.ativos}</div>
        </div>
        <div style={styles.counterCard('#c62828')}>
          <div style={styles.counterLabel}>Bloqueados</div>
          <div style={{ ...styles.counterValue, color: '#c62828' }}>{contadores.bloqueados}</div>
        </div>
      </div>

      {/* Filtros */}
      <div className="responsive-flex page-filters" style={styles.filtersCard}>
        <div style={{ ...styles.filterGroup, flex: '2 1 300px' }}>
          <label style={styles.filterLabel}>Buscar</label>
          <input
            type="text"
            placeholder="Buscar por codigo, descricao ou sinonimo..."
            value={filtros.search}
            onChange={(e) => setFiltros({ ...filtros, search: e.target.value })}
            style={styles.searchInput}
          />
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 180px' }}>
          <label style={styles.filterLabel}>Material</label>
          <select
            value={filtros.material}
            onChange={(e) => setFiltros({ ...filtros, material: e.target.value })}
            style={styles.filterSelect}
          >
            <option value="">Todos</option>
            {materiais.map(mat => (
              <option key={mat.ID} value={mat.ID}>{mat.DESCRICAO}</option>
            ))}
          </select>
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 180px' }}>
          <label style={styles.filterLabel}>Metodo</label>
          <select
            value={filtros.metodo}
            onChange={(e) => setFiltros({ ...filtros, metodo: e.target.value })}
            style={styles.filterSelect}
          >
            <option value="">Todos</option>
            {metodos.map(met => (
              <option key={met.ID} value={met.ID}>{met.DESCRICAO}</option>
            ))}
          </select>
        </div>
        <div style={{ ...styles.filterGroup, flex: '0 1 150px' }}>
          <label style={styles.filterLabel}>Status</label>
          <select
            value={filtros.bloqueado}
            onChange={(e) => setFiltros({ ...filtros, bloqueado: e.target.value })}
            style={styles.filterSelect}
          >
            <option value="">Todos</option>
            <option value="false">Ativos</option>
            <option value="true">Bloqueados</option>
          </select>
        </div>
        {(filtros.search || filtros.material || filtros.metodo || filtros.bloqueado) && (
          <button
            style={styles.clearButton}
            onClick={() => setFiltros({ search: '', material: '', metodo: '', bloqueado: 'false' })}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#e0e0e0'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#f5f5f5'; }}
          >
            Limpar Filtros
          </button>
        )}
      </div>

      {/* Tabela Desktop */}
      <div className="laudos-desktop" style={styles.tableCard}>
        <div style={styles.tableResponsive}>
          <table className="data-table" style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, width: '80px' }}>Codigo</th>
                <th style={styles.th}>Descricao</th>
                <th style={styles.th}>Sinonimo</th>
                <th style={styles.th}>Material</th>
                <th style={styles.th}>Metodo</th>
                <th style={{ ...styles.th, width: '60px', textAlign: 'center' }}>Sexo</th>
                <th style={{ ...styles.th, width: '80px', textAlign: 'center' }}>Dias Entrega</th>
                <th style={{ ...styles.th, width: '100px', textAlign: 'center' }}>Status</th>
                <th style={{ ...styles.th, width: '100px', textAlign: 'center' }}>Acoes</th>
              </tr>
            </thead>
            <tbody>
              {laudos.length === 0 ? (
                <tr>
                  <td colSpan="9" style={styles.emptyState}>Nenhum laudo encontrado.</td>
                </tr>
              ) : (
                laudos.map((laudo, index) => (
                  <tr
                    key={laudo.ID}
                    style={{
                      ...(index % 2 === 0 ? {} : styles.trEven),
                      ...(hoveredRow === index ? { backgroundColor: '#e3f2fd' } : {}),
                      cursor: 'pointer',
                      transition: 'background-color 0.15s',
                    }}
                    onClick={() => navigate(`/laudos/${laudo.ID}`)}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                  >
                    <td style={{ ...styles.td, fontWeight: '600' }}>{laudo.ID}</td>
                    <td style={styles.td}>{laudo.DESCRICAO || '-'}</td>
                    <td style={{ ...styles.td, fontSize: '0.85rem', color: '#666' }}>{laudo.SINONIMO || '-'}</td>
                    <td style={styles.td}>{laudo.MATERIAL_NOME || '-'}</td>
                    <td style={styles.td}>{laudo.METODO_NOME || '-'}</td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>{laudo.SEXO || '-'}</td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>{laudo.DIASENTREGA || '-'}</td>
                    <td style={{ ...styles.td, textAlign: 'center' }}>
                      <span style={laudo.BLOQUEADO === 'T' ? styles.badgeBloqueado : styles.badgeAtivo}>
                        {laudo.BLOQUEADO === 'T' ? 'Bloqueado' : 'Ativo'}
                      </span>
                    </td>
                    <td style={{ ...styles.td, textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                      <button
                        style={{ ...styles.actionButton, ...styles.editButton }}
                        onClick={() => abrirModalEdicao(laudo)}
                        title="Editar"
                      >
                        Editar
                      </button>
                      {laudo.BLOQUEADO !== 'T' && (
                        <button
                          style={{ ...styles.actionButton, ...styles.blockButton }}
                          onClick={() => bloquearLaudo(laudo.ID)}
                          title="Bloquear"
                        >
                          Bloquear
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile: Cards */}
      <div className="laudos-mobile">
        {laudos.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
            Nenhum laudo encontrado.
          </div>
        ) : (
          laudos.map((laudo) => {
            const bloqueado = laudo.BLOQUEADO === 'T';
            return (
              <div
                key={laudo.ID}
                className="laudo-list-card"
                onClick={() => navigate(`/laudos/${laudo.ID}`)}
              >
                <div className="laudo-list-card-header">
                  <span className="laudo-list-card-codigo">{laudo.ID}</span>
                  <span className={`laudo-list-card-status ${bloqueado ? 'bloqueado' : 'ativo'}`}>
                    {bloqueado ? 'Bloqueado' : 'Ativo'}
                  </span>
                </div>
                <div className="laudo-list-card-nome">{laudo.DESCRICAO || '-'}</div>
                <div className="laudo-list-card-meta">
                  {laudo.MATERIAL_NOME && <span>Mat: {laudo.MATERIAL_NOME}</span>}
                  {laudo.METODO_NOME && <span>Met: {laudo.METODO_NOME}</span>}
                  {laudo.SEXO && <span>Sexo: {laudo.SEXO}</span>}
                  {laudo.DIASENTREGA && <span>{laudo.DIASENTREGA} dias</span>}
                </div>
                <div className="laudo-list-card-actions" onClick={(e) => e.stopPropagation()}>
                  <button
                    className="laudo-list-card-btn edit"
                    onClick={() => abrirModalEdicao(laudo)}
                    title="Editar"
                  >
                    Editar
                  </button>
                  {!bloqueado && (
                    <button
                      className="laudo-list-card-btn block"
                      onClick={() => bloquearLaudo(laudo.ID)}
                      title="Bloquear"
                    >
                      Bloquear
                    </button>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Paginacao */}
      {totalPages > 1 && (
        <div style={styles.paginationContainer}>
          <button
            style={styles.paginationBtn(false)}
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
          >
            Anterior
          </button>
          {Array.from({ length: Math.min(totalPages, 7) }, (_, i) => {
            let page;
            if (totalPages <= 7) {
              page = i + 1;
            } else if (currentPage <= 4) {
              page = i + 1;
            } else if (currentPage >= totalPages - 3) {
              page = totalPages - 6 + i;
            } else {
              page = currentPage - 3 + i;
            }
            return (
              <button
                key={page}
                style={styles.paginationBtn(page === currentPage)}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            );
          })}
          <button
            style={styles.paginationBtn(false)}
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
          >
            Proximo
          </button>
          <span style={styles.paginationInfo}>
            {totalItems} registros
          </span>
        </div>
      )}

      {/* Modal de Edicao/Criacao */}
      {modalOpen && (
        <div style={styles.overlay} onClick={fecharModal}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h2 style={styles.modalTitle}>{modoEdicao ? 'Editar Laudo' : 'Novo Laudo'}</h2>
              <button
                style={styles.modalCloseButton}
                onClick={fecharModal}
                onMouseEnter={(e) => { e.target.style.color = '#333'; }}
                onMouseLeave={(e) => { e.target.style.color = '#999'; }}
              >
                X
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={styles.modalBody}>
                <div className="responsive-grid" style={styles.formGrid}>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Codigo *</label>
                    <input
                      type="text"
                      name="ID"
                      value={formData.ID}
                      onChange={handleInputChange}
                      required
                      disabled={modoEdicao}
                      style={{
                        ...styles.formInput,
                        ...(modoEdicao ? { backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' } : {}),
                      }}
                    />
                  </div>
                  <div style={styles.formGroupFull}>
                    <label style={styles.formLabel}>Descricao *</label>
                    <input
                      type="text"
                      name="DESCRICAO"
                      value={formData.DESCRICAO}
                      onChange={handleInputChange}
                      required
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroupFull}>
                    <label style={styles.formLabel}>Sinonimo</label>
                    <input
                      type="text"
                      name="SINONIMO"
                      value={formData.SINONIMO}
                      onChange={handleInputChange}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Material</label>
                    <select name="MATERIAL" value={formData.MATERIAL} onChange={handleInputChange} style={styles.filterSelect}>
                      <option value="">Selecione</option>
                      {materiais.map(mat => (
                        <option key={mat.ID} value={mat.ID}>{mat.DESCRICAO}</option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Metodo</label>
                    <select name="METODO" value={formData.METODO} onChange={handleInputChange} style={styles.filterSelect}>
                      <option value="">Selecione</option>
                      {metodos.map(met => (
                        <option key={met.ID} value={met.ID}>{met.DESCRICAO}</option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Sexo</label>
                    <select name="SEXO" value={formData.SEXO} onChange={handleInputChange} style={styles.filterSelect}>
                      <option value="">Todos</option>
                      <option value="M">Masculino</option>
                      <option value="F">Feminino</option>
                    </select>
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Dias para Entrega</label>
                    <input
                      type="number"
                      name="DIASENTREGA"
                      value={formData.DIASENTREGA}
                      onChange={handleInputChange}
                      min="0"
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.formLabel}>Codigo TUSS</label>
                    <input
                      type="text"
                      name="CODIGO_TUSS"
                      value={formData.CODIGO_TUSS}
                      onChange={handleInputChange}
                      style={styles.formInput}
                    />
                  </div>
                  <div style={styles.formGroupFull}>
                    <label style={styles.formLabel}>Preparo</label>
                    <textarea
                      name="PREPARO"
                      value={formData.PREPARO}
                      onChange={handleInputChange}
                      rows="3"
                      style={styles.formTextarea}
                    />
                  </div>
                  <div style={styles.formGroupFull}>
                    <label style={styles.formLabel}>Observacao Padrao</label>
                    <textarea
                      name="OBSPADRAO"
                      value={formData.OBSPADRAO}
                      onChange={handleInputChange}
                      rows="3"
                      style={styles.formTextarea}
                    />
                  </div>
                  {modoEdicao && (
                    <div style={styles.formGroupFull}>
                      <label style={{ ...styles.formLabel, display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={formData.BLOQUEADO === 'T'}
                          onChange={(e) => setFormData({ ...formData, BLOQUEADO: e.target.checked ? 'T' : 'F' })}
                          style={{ width: '18px', height: '18px' }}
                        />
                        Bloqueado
                      </label>
                    </div>
                  )}
                </div>
              </div>

              <div style={styles.modalFooter}>
                <button type="button" onClick={fecharModal} style={styles.btnCancelar}>
                  Cancelar
                </button>
                <button type="submit" style={styles.btnSalvar}>
                  {modoEdicao ? 'Atualizar' : 'Criar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Laudos;
